import { Attachment } from './Attachment'
import { Form } from './DynamicComponent'

interface InsurerI18n {
  [key: string]: string
}

export const enum InsurerFormsType {
  DEFAULT = 'DEFAULT',
  CUSTOM = 'CUSTOM',
}

export const enum ProviderType {
  IN_NETWORK = 'IN_NETWORK',
  OUT_OF_NETWORK = 'OUT_OF_NETWORK',
  UNKNOWN = 'UNKNOWN',
}

export const enum AvailableChannelType {
  ONLINE = 'ONLINE',
  IN_STORE = 'IN_STORE',
  CUSTOMER_SERVICE = 'CUSTOMER_SERVICE',
  CUSTOMER_FORM = 'CUSTOMER_FORM',
}

export interface Insurer {
  id: string
  insurerName: InsurerI18n
  active: boolean
  insuranceProviderId: string
  dynamicFormsType: InsurerFormsType
  availableChannels?: AvailableChannelType[]
  attachment?: Attachment
  providerId: string
  providerType: ProviderType
}

export const enum InsurerErrorType {
  RESTRICTED_PRODUCT_ERROR = 'RESTRICTED_PRODUCT_ERROR',
  NO_ELIGIBLE_PRODUCT_ERROR = 'NO_ELIGIBLE_PRODUCT_ERROR',
}

export interface InsurerDetails {
  dynamicFormsType: InsurerFormsType
  dynamicFormsConfig: {
    formGroups: Form[]
  }
}

export interface InsurerDetailArgs {
  insurerId: string
}

export interface DefaultFormArgs {
  insuranceProviderId: string
}

export interface InsuranceProvider {
  id: string
}

export interface InsuranceProviderArgs {
  insuranceProviderId: string
}
